<template>
  <v-dialog v-model="dialog" max-width="1000px" persistent>
    <v-card class="modal-card">
      <v-card-text class="pa-8">
        <div class="text-center mb-6">
          <h2 class="modal-title">Solicitação de loja própria White Label</h2>
        </div>

        <div class="modal-content mb-6">
          <p class="text-body-1 mb-4 text-justify line-height-1-5">
            Além de presença no inventário do Canal do Anúncio e Canal do Mídia, 
            agora você pode ter a loja digital de mídia para seu veículo. Uma 
            plataforma white label alimentada pela tecnologia e know-how da The 
            Media Trade, integrada ao seu inventário e fluxo comercial. Cadastre seu 
            inventário, personalize com a cara e políticas comerciais do seu veículo e 
            comece a vender de forma digital!
          </p>

          <p class="text-body-1 mb-6 text-justify line-height-1-5">
            A contratação da sua loja é feita a partir da assinatura de planos anuais. <br>
            Solicite o agendamento de uma reunião para receber sua proposta.
          </p>

          <div class="text-center mb-6">
            <v-btn 
              color="#1976d2" 
              dark
              large 
              class="font-weight-normal px-8 py-3 modal-button"
            href="https://calendly.com/themediatrade-maggi"
            target="_blank"
              elevation="2"
            >
              Quero ter a minha loja
              <v-icon right class="ml-2">mdi-store</v-icon>
            </v-btn>
            
            <br>
            
            <v-btn 
              color="white" 
              outlined
              class="font-weight-normal px-6 py-2 mt-3 secondary-button"
              @click="goToWhiteLabel"
              elevation="0"
            >
              Saiba mais
            </v-btn>
          </div>
        </div>

        <div class="text-right">
          <v-btn 
            color="success" 
            text 
            @click="closeModal"
            class="font-weight-normal modal-ok-button"
          >
            Ok, entendi
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'WhiteLabelModal',
  
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    dialog: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },

  methods: {
    goToWhiteLabel() {
      this.closeModal()
      this.$router.push('/whitelabel?signed&cdv')
    },

    closeModal() {
      this.$emit('input', false)
    }
  }
}
</script>

<style scoped>
.modal-card {
  border: 3px solid #1976d2;
  border-radius: 8px;
}

.modal-title {
  font-size: 2rem;
  font-weight: bold;
  color: #000;
  line-height: 1.2;
  margin: 0;
}

.modal-content {
  max-width: 100%;
}

.text-justify {
  text-align: justify;
}

.line-height-1-5 {
  line-height: 1.5;
}

.modal-button {
  font-size: 1.1rem;
  text-transform: none;
  border-radius: 8px;
  min-height: 48px;
  font-weight: 500;
}

.secondary-button {
  font-size: 0.95rem;
  text-transform: none;
  border-radius: 6px;
  min-height: 40px;
  border: 2px solid #1976d2 !important;
  color: #1976d2 !important;
}

.secondary-button:hover {
  background-color: rgba(25, 118, 210, 0.04) !important;
}

.modal-ok-button {
  font-size: 1rem;
  text-transform: none;
  border: 2px solid #4caf50;
  border-radius: 6px;
  padding: 8px 24px;
}

.modal-ok-button:hover {
  background-color: rgba(76, 175, 80, 0.04);
}

/* Remove espaçamento extra dos parágrafos */
p {
  margin: 0;
}
</style>
